// src/services/tenantUsersApi.js
import { getJson, patchJson, postJson } from './http';
export async function listTenantUsers(tenant) {
  return getJson(`/api/tenants/${tenant}/users`);
}
export async function setUserActive(tenant, userId, active) {
  return patchJson(`/api/tenants/${tenant}/users/${userId}`, { active: active ? 1 : 0 });
}
export async function getTenantUser(tenant, userId) {
  return getJson(`/api/tenants/${tenant}/users/${userId}`);
}
export async function updateTenantUser(tenant, userId, body) {
  return patchJson(`/api/tenants/${tenant}/users/${userId}`, body);
}
export async function canAddUser(tenant) {
  return getJson(`/api/tenants/${tenant}/can-add-user`);
}
export async function registerUser(tenant, body) {
  return postJson(`/api/tenants/${tenant}/registeruser`, body);
}